import React, { useCallback } from 'react'

import { Button, ButtonColorVariant } from '@gousto-internal/citrus-react'
import { CopyConfirmation } from 'SocialLinks/CopyConfirmation'
import type { ShareSurface } from 'SocialLinks/shareNatively'
import { appendNativeShareUtm } from 'SocialLinks/shareNatively'
import { getMessage, getReferralLink, SHARE_TITLE } from 'SocialLinks/socialReferralHelper'
import { useShareWithFallback } from 'SocialLinks/useShareWithFallback'
import classnames from 'classnames'
import type Immutable from 'immutable'

import { actionTypes } from 'actions/actionTypes'

import css from './SocialShareSheetCTA.css'

interface Props {
  referralCode: string
  isFixed: boolean
  trackingReferFriend: (actionType: string, actionName: string) => void
  trackUserFreeFoodLinkShare: (payload: { target: string }) => void
  surface: ShareSurface
  rafOffer: Immutable.Map<string, unknown>
}

export const SocialShareSheetCTA = ({
  referralCode,
  isFixed,
  trackingReferFriend,
  trackUserFreeFoodLinkShare,
  surface,
  rafOffer,
}: Props) => {
  const referralLink = getReferralLink(referralCode, '', '&utm_source=weblink')
  const credit = rafOffer.get('creditFormatted') as string

  const onOpened = useCallback(
    () =>
      trackingReferFriend(actionTypes.REFER_FRIEND_LINK_SHARE, 'NativeReferFriendInterface Opened'),
    [trackingReferFriend],
  )

  const { isCopied, share } = useShareWithFallback({
    copyText: referralLink,
    surface,
    trackingReferFriend,
    trackUserFreeFoodLinkShare,
    onOpened,
  })

  const onClick = useCallback(() => {
    share({
      title: SHARE_TITLE,
      url: appendNativeShareUtm(getReferralLink(referralCode)),
      text: getMessage(rafOffer),
    })
  }, [referralCode, rafOffer, share])

  const ctaContainerClasses = classnames(css.mobileShow, css.ctaContainer, {
    [css.fixedMobileCTAContainer]: isFixed,
  })

  return (
    <div className={ctaContainerClasses}>
      <Button onClick={onClick} colorVariant={ButtonColorVariant.Secondary} width="100%">
        Share your link
      </Button>
      {isCopied && <CopyConfirmation credit={credit} />}
    </div>
  )
}
